import axios from "axios";

export interface PrazoDto {
    id: number;
    descricao: string;
    parcela: number;
    createdAt: string;
    updatedAt: string;
    isDeleted: boolean;
    formasPagamentoCount: number;
}

export interface PrazoDetalheDto {
    id: number;
    descricao: string;
    parcela: number;
    createdAt: string;
    updatedAt: string;
    isDeleted: boolean;
    formasPagamentoCount: number;
    formasPagamento: FormaPagamentoAssociadaDto[];
}

export interface FormaPagamentoAssociadaDto {
    id: number;
    descricao: string;
    tipo: string;
    isDeleted: boolean;
}

export interface CriarPrazosDto {
    quantidadeParcelas: number;
}

export interface CriarPrazosResponse {
    prazosIds: number[];
}

export interface AlterarPrazoDto {
    descricao: string;
}



export const prazoService = {
    async listar(incluirInativos = false): Promise<PrazoDto[]> {
        const response = await axios.get(`/api/prazo?incluirInativos=${incluirInativos}`);
        return response.data;
    },

    async obterPorId(id: number): Promise<PrazoDetalheDto> {
        const response = await axios.get(`/api/prazo/${id}`);
        return response.data;
    },

    async criarPrazos(data: CriarPrazosDto): Promise<CriarPrazosResponse> {
        const response = await axios.post('/api/prazo', data);
        return response.data;
    },

    async alterar(id: number, data: AlterarPrazoDto): Promise<void> {
        await axios.put(`/api/prazo/${id}`, data);
    },

    async excluir(id: number): Promise<void> {
        await axios.delete(`/api/prazo/${id}`);
    },

    async reativar(id: number): Promise<void> {
        await axios.patch(`/api/prazo/${id}/reativar`);
    },


};